"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PAYCODES_API = exports.GET_BALANCES_API = exports.ACKNOWLEDGE_ANOMALY = exports.ANOMALY_SEARCH_API = exports.EDIT_PAY_CODES_API = exports.ADD_PAY_CODES_API = exports.GET_PAY_CODES_SUMMARY_API = exports.GET_PAY_CODES_API = exports.SUBMIT_DELETE_PUNCH_V2_API = exports.GET_PUNCH_CORR_STATUS_V1_LIST_API = exports.GET_PUNCH_CORR_STATUS_LIST_API = exports.GET_SCHEDULE_API = exports.GET_PAY_CALENDAR_API = exports.GET_PAY_PERIOD_CALENDAR_API = exports.GET_PAY_CODE_POLICY_API = exports.SUBMIT_PUNCH_APPROVAL_REVIEW = exports.UPDATE_PAY_DATA_API = exports.GET_PAY_DATA_API = exports.GET_PAY_PERIOD_RANGE_API = exports.UPDATE_PUNCH_CORRECTION_API = exports.ACCEPT_PUNCH_CORRECTION_API = exports.GET_PUNCH_CORRECTIONS_API = exports.GET_PAY_PERIOD_API = exports.SUBMIT_PUNCH_CTK_API = exports.SUBMIT_PUNCH_API = exports.EDIT_PUNCH_API = exports.SUBMIT_MISSED_PUNCH_V2_API = exports.GET_EDIT_PUNCH_LOCKOUT_STATUS_API = exports.GET_MISSED_PUNCH_LOCKOUT_STATUS_API = exports.DELETE_PUNCH_API = exports.GET_UNIFIED_PUNCHES_API = exports.GET_PUNCHES_ELIGIBILITY_API = exports.GET_PUNCHES_API = exports.GET_PEOPLE_TECH_FEATURE_GATE_SERVICE_API = exports.SUBMIT_TRAVEL_TIME_API = exports.appendOptionalParams = exports.parseQueryParameters = exports.ApiRoot = void 0;
const query_string_1 = require("query-string");
var ApiRoot;
(function (ApiRoot) {
    ApiRoot["PunchesEligibility"] = "/punch/eligibility";
    ApiRoot["Punches"] = "/punches";
    ApiRoot["PayData"] = "/payData";
    ApiRoot["PayCodePolicy"] = "/payCodePolicy";
    ApiRoot["CTKPunches"] = "/user_feedback/submit_punch";
    ApiRoot["SubmitMissingPunch"] = "/punches/submitMissingPunch";
    ApiRoot["PunchCorrections"] = "/punchCorrections";
    ApiRoot["PayPeriod"] = "/v2/timeoff/payPeriod";
    ApiRoot["PayPeriodRange"] = "/v2/timeoff/payPeriod/range";
    ApiRoot["MissedPunchLockoutStatus"] = "/associateAipLockoutStatus";
    ApiRoot["EditPunchLockoutStatus"] = "/v2/boxeraip/punch/edit/lockout-status";
    ApiRoot["EditPunch"] = "/v2/request/punch/edit";
    ApiRoot["SubmitMissedPunchV2"] = "/v2/request/punch/add";
    ApiRoot["Pay_Calendar"] = "/api/v1/compensation/pay_calendar";
    ApiRoot["PayCalendar"] = "/payCalendar";
    ApiRoot["Schedule"] = "/timeoff/schedules";
    ApiRoot["PunchCorrStatusList"] = "/v2/employee/:employeeId/request/status-updates/punch-correction";
    ApiRoot["PunchCorrStatusV1List"] = "/v2/employee/:employeeId/request/status-updates/punch-correction-v1";
    ApiRoot["SubmitDeletePunch"] = "/v2/request/punch/delete";
    ApiRoot["SubmitApprovalReview"] = "/v2/boxeraip/punch/request-approval";
    ApiRoot["UnifiedPunches"] = "/v2/punch/search";
    ApiRoot["PeopleTechFeatureGateService"] = "/api/v1/feature/get_features";
    ApiRoot["PayCodes"] = "/v2/paycodes";
    ApiRoot["PayCodesSummary"] = "/v2/paycodes/summary";
    ApiRoot["AddPayCode"] = "/paycode/add";
    ApiRoot["EditPayCode"] = "/v2/paycode/edit";
    ApiRoot["AnomalySearch"] = "/v2/anomaly/search";
    ApiRoot["CreateCtkCase"] = "/router";
    ApiRoot["AcknowledgeAnomaly"] = "/v2/anomaly/close";
    ApiRoot["GetBalances"] = "/timeoff/balances";
    ApiRoot["GetPaycodes"] = "/v2/paycodes";
})(ApiRoot = exports.ApiRoot || (exports.ApiRoot = {}));
const parseQueryParameters = (params) => {
    const parsedParams = (0, query_string_1.stringify)(params);
    return parsedParams ? `?${parsedParams}` : '';
};
exports.parseQueryParameters = parseQueryParameters;
const appendOptionalParams = (baseParams, params, shouldAdd) => {
    return shouldAdd ? Object.assign(Object.assign({}, baseParams), params) : baseParams;
};
exports.appendOptionalParams = appendOptionalParams;
const SUBMIT_TRAVEL_TIME_API = (queryParams) => {
    return `${ApiRoot.CreateCtkCase}` + '?' + new URLSearchParams(queryParams);
};
exports.SUBMIT_TRAVEL_TIME_API = SUBMIT_TRAVEL_TIME_API;
const GET_PEOPLE_TECH_FEATURE_GATE_SERVICE_API = () => `${ApiRoot.PeopleTechFeatureGateService}`;
exports.GET_PEOPLE_TECH_FEATURE_GATE_SERVICE_API = GET_PEOPLE_TECH_FEATURE_GATE_SERVICE_API;
const GET_PUNCHES_API = (employeeId, startDate, endDate, temporalRouting) => {
    const params = (0, exports.appendOptionalParams)({
        employeeId,
        startDate,
        endDate
    }, {
        temporalRouting: 'true'
    }, temporalRouting);
    const queryParams = (0, exports.parseQueryParameters)(params);
    return `${ApiRoot.Punches}${queryParams}`;
};
exports.GET_PUNCHES_API = GET_PUNCHES_API;
const GET_PUNCHES_ELIGIBILITY_API = (employeeId, startDate, endDate, temporalRouting) => {
    const params = (0, exports.appendOptionalParams)({
        employeeId,
        startDate,
        endDate
    }, {
        temporalRouting: 'true'
    }, temporalRouting);
    const queryParams = (0, exports.parseQueryParameters)(params);
    return `${ApiRoot.PunchesEligibility}${queryParams}`;
};
exports.GET_PUNCHES_ELIGIBILITY_API = GET_PUNCHES_ELIGIBILITY_API;
const GET_UNIFIED_PUNCHES_API = (employeeId, startDate, endDate, timezone, extendEligibility, countryCode) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId,
        startDate,
        endDate,
        timezone,
        extendEligibility: extendEligibility === null || extendEligibility === void 0 ? void 0 : extendEligibility.toString(),
        countryCode
    });
    return `${ApiRoot.UnifiedPunches}${queryParams}`;
};
exports.GET_UNIFIED_PUNCHES_API = GET_UNIFIED_PUNCHES_API;
const DELETE_PUNCH_API = (employeeId) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId
    });
    return `${ApiRoot.Punches}${queryParams}`;
};
exports.DELETE_PUNCH_API = DELETE_PUNCH_API;
const GET_MISSED_PUNCH_LOCKOUT_STATUS_API = (employeeId) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId
    });
    return `${ApiRoot.MissedPunchLockoutStatus}${queryParams}`;
};
exports.GET_MISSED_PUNCH_LOCKOUT_STATUS_API = GET_MISSED_PUNCH_LOCKOUT_STATUS_API;
const GET_EDIT_PUNCH_LOCKOUT_STATUS_API = (employeeId) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId
    });
    return `${ApiRoot.EditPunchLockoutStatus}/${employeeId}${queryParams}`;
};
exports.GET_EDIT_PUNCH_LOCKOUT_STATUS_API = GET_EDIT_PUNCH_LOCKOUT_STATUS_API;
const SUBMIT_MISSED_PUNCH_V2_API = (employeeId) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId
    });
    return `${ApiRoot.SubmitMissedPunchV2}${queryParams}`;
};
exports.SUBMIT_MISSED_PUNCH_V2_API = SUBMIT_MISSED_PUNCH_V2_API;
const EDIT_PUNCH_API = (employeeId) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId
    });
    return `${ApiRoot.EditPunch}${queryParams}`;
};
exports.EDIT_PUNCH_API = EDIT_PUNCH_API;
const SUBMIT_PUNCH_API = (employeeId) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId
    });
    return `${ApiRoot.SubmitMissingPunch}${queryParams}`;
};
exports.SUBMIT_PUNCH_API = SUBMIT_PUNCH_API;
const SUBMIT_PUNCH_CTK_API = () => `${ApiRoot.CTKPunches}`;
exports.SUBMIT_PUNCH_CTK_API = SUBMIT_PUNCH_CTK_API;
const GET_PAY_PERIOD_API = (employeeId) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId
    });
    return `${ApiRoot.PayPeriod}${queryParams}`;
};
exports.GET_PAY_PERIOD_API = GET_PAY_PERIOD_API;
const GET_PUNCH_CORRECTIONS_API = (employeeId, startDateTime, endDateTime) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId,
        startDateTime,
        endDateTime
    });
    return `${ApiRoot.PunchCorrections}${queryParams}`;
};
exports.GET_PUNCH_CORRECTIONS_API = GET_PUNCH_CORRECTIONS_API;
const ACCEPT_PUNCH_CORRECTION_API = (employeeId, correctionId) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId,
        correctionId
    });
    return `${ApiRoot.PunchCorrections}${queryParams}`;
};
exports.ACCEPT_PUNCH_CORRECTION_API = ACCEPT_PUNCH_CORRECTION_API;
const UPDATE_PUNCH_CORRECTION_API = (employeeId, correctionId) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId,
        correctionId
    });
    return `${ApiRoot.PunchCorrections}${queryParams}`;
};
exports.UPDATE_PUNCH_CORRECTION_API = UPDATE_PUNCH_CORRECTION_API;
const GET_PAY_PERIOD_RANGE_API = (urlProps) => {
    const queryParams = (0, exports.parseQueryParameters)(Object.assign({}, urlProps));
    return `${ApiRoot.PayPeriodRange}${queryParams}`;
};
exports.GET_PAY_PERIOD_RANGE_API = GET_PAY_PERIOD_RANGE_API;
const GET_PAY_DATA_API = (employeeId, startDate, endDate) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId,
        startDate,
        endDate
    });
    return `${ApiRoot.PayData}${queryParams}`;
};
exports.GET_PAY_DATA_API = GET_PAY_DATA_API;
const UPDATE_PAY_DATA_API = (employeeId) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId
    });
    return `${ApiRoot.PayData}${queryParams}`;
};
exports.UPDATE_PAY_DATA_API = UPDATE_PAY_DATA_API;
const SUBMIT_PUNCH_APPROVAL_REVIEW = (referenceId, employeeId, requestId) => {
    const queryParams = (0, exports.parseQueryParameters)({
        aipId: referenceId,
        employeeId: employeeId,
        requestId: requestId
    });
    return `${ApiRoot.SubmitApprovalReview}${queryParams}`;
};
exports.SUBMIT_PUNCH_APPROVAL_REVIEW = SUBMIT_PUNCH_APPROVAL_REVIEW;
const GET_PAY_CODE_POLICY_API = (employeeId, startDateTime, endDateTime, language) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId,
        startDateTime,
        endDateTime,
        language
    });
    return `${ApiRoot.PayCodePolicy}${queryParams}`;
};
exports.GET_PAY_CODE_POLICY_API = GET_PAY_CODE_POLICY_API;
const GET_PAY_PERIOD_CALENDAR_API = (start, end) => {
    const queryParams = (0, exports.parseQueryParameters)({
        start,
        end
    });
    return `${ApiRoot.Pay_Calendar}${queryParams}`;
};
exports.GET_PAY_PERIOD_CALENDAR_API = GET_PAY_PERIOD_CALENDAR_API;
const GET_PAY_CALENDAR_API = (employeeId, startDate, endDate) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId,
        startDate,
        endDate
    });
    return `${ApiRoot.PayCalendar}${queryParams}`;
};
exports.GET_PAY_CALENDAR_API = GET_PAY_CALENDAR_API;
const GET_SCHEDULE_API = (employeeId, startDateTime, endDateTime, temporalRouting) => {
    const params = (0, exports.appendOptionalParams)({
        employeeId,
        startDateTime,
        endDateTime
    }, {
        temporalRouting: 'true'
    }, temporalRouting);
    const queryParams = (0, exports.parseQueryParameters)(params);
    return `${ApiRoot.Schedule}${queryParams}`;
};
exports.GET_SCHEDULE_API = GET_SCHEDULE_API;
const GET_PUNCH_CORR_STATUS_LIST_API = (employeeId, startDateTime, endDateTime) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId,
        startDateTime,
        endDateTime
    });
    return `${ApiRoot.PunchCorrStatusList.replace(/:employeeId/g, employeeId)}${queryParams}`;
};
exports.GET_PUNCH_CORR_STATUS_LIST_API = GET_PUNCH_CORR_STATUS_LIST_API;
const GET_PUNCH_CORR_STATUS_V1_LIST_API = (employeeId, startDateTime, endDateTime) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId,
        startDateTime,
        endDateTime
    });
    return `${ApiRoot.PunchCorrStatusV1List.replace(/:employeeId/g, employeeId)}${queryParams}`;
};
exports.GET_PUNCH_CORR_STATUS_V1_LIST_API = GET_PUNCH_CORR_STATUS_V1_LIST_API;
const SUBMIT_DELETE_PUNCH_V2_API = (employeeId) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId
    });
    return `${ApiRoot.SubmitDeletePunch}${queryParams}`;
};
exports.SUBMIT_DELETE_PUNCH_V2_API = SUBMIT_DELETE_PUNCH_V2_API;
const GET_PAY_CODES_API = (employeeId, startDateTime, endDateTime, language) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId,
        startDateTime,
        endDateTime,
        language
    });
    return `${ApiRoot.PayCodes}${queryParams}`;
};
exports.GET_PAY_CODES_API = GET_PAY_CODES_API;
const GET_PAY_CODES_SUMMARY_API = (employeeId, startDateTime, endDateTime, timezone) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId,
        startDateTime,
        endDateTime,
        includeTimecardPaycodes: 'true',
        timezone
    });
    return `${ApiRoot.PayCodesSummary}${queryParams}`;
};
exports.GET_PAY_CODES_SUMMARY_API = GET_PAY_CODES_SUMMARY_API;
const ADD_PAY_CODES_API = (employeeId) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId
    });
    return `${ApiRoot.AddPayCode}${queryParams}`;
};
exports.ADD_PAY_CODES_API = ADD_PAY_CODES_API;
const EDIT_PAY_CODES_API = (employeeId) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId
    });
    return `${ApiRoot.EditPayCode}${queryParams}`;
};
exports.EDIT_PAY_CODES_API = EDIT_PAY_CODES_API;
const ANOMALY_SEARCH_API = (employeeId, startDate, endDate, anomalyTypes, deviationStatus) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId,
        startDate,
        endDate,
        anomalyTypes,
        deviationStatus
    });
    return `${ApiRoot.AnomalySearch}${queryParams}`;
};
exports.ANOMALY_SEARCH_API = ANOMALY_SEARCH_API;
const ACKNOWLEDGE_ANOMALY = (deviationId) => {
    return `${ApiRoot.AcknowledgeAnomaly}`;
};
exports.ACKNOWLEDGE_ANOMALY = ACKNOWLEDGE_ANOMALY;
const GET_BALANCES_API = (employeeId, targetDateTime) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId,
        targetDateTime
    });
    return `${ApiRoot.GetBalances}${queryParams}`;
};
exports.GET_BALANCES_API = GET_BALANCES_API;
const GET_PAYCODES_API = (employeeId, startDateTime, endDateTime, useV4Api) => {
    const queryParams = (0, exports.parseQueryParameters)({
        employeeId,
        startDateTime,
        endDateTime,
        useV4Api
    });
    return `${ApiRoot.GetPaycodes}${queryParams}`;
};
exports.GET_PAYCODES_API = GET_PAYCODES_API;
